
export const Constantes = {
  CNPJ_PREVIC: '07290290000102',

  //CAND
  //...

  //CAD
  EFPC_SITUACAO_NORMAL: 1, //SituacaoPrimariaEfpcEnum

} as const;


//DirigenteCategoria
// 1 : Diretor Executivo / 2 : Conselheiro Deliberativo / 3 : Conselheiro Fiscal
export const CategoriasDirigente = {
    "DIRETOR": { "value": 1, "label": "Diretor" },
    "DELIBERATIVO": { "value": 2, "label": "Deliberativo" },
    "FISCAL": { "value": 3, "label": "Fiscal" },
};

export const lista_areas_certificadoras = [
    { "value": "1", "label": "Administrativa" },
    { "value": "2", "label": "Atuarial" },
    { "value": "3", "label": "Auditoria" },
    { "value": "4", "label": "Contábil" },
    { "value": "5", "label": "Financeira/Investimentos" },
    { "value": "6", "label": "Governança" },
    { "value": "7", "label": "Jurídica" }
];

 export const lista_tipo_formacao = [
    { "enum": 1, "tipoFormacao": "CAPACITAÇÃO" },
    { "enum": 2, "tipoFormacao": "TÉCNICO" },
    { "enum": 3, "tipoFormacao": "TECNÓLOGO" },
    { "enum": 4, "tipoFormacao": "BACHARELADO" },
    { "enum": 5, "tipoFormacao": "LICENCIATURA" },
    { "enum": 6, "tipoFormacao": "ESPECIALIZAÇÃO" },
    { "enum": 7, "tipoFormacao": "MESTRADO" },
    { "enum": 8, "tipoFormacao": "DOUTORADO" },
    { "enum": 9, "tipoFormacao": "PÓS-DOUTORADO" },
]

// Enum for 'PESSOA_FISICA_EXPERIENCIA_PROFISSIONAL'
export const lista_enumNivel = [
    { "enum": 1, "nivel": "OPERACIONAL" },
    { "enum": 2, "nivel": "TÁTICO/GERENCIAL" },
    { "enum": 3, "nivel": "ESTRATÉGICO" },
]

export const lista_tipoVinculo = [
    { "enum": 1, "tipoVinculo": "EMPREGO PRIVADO" },
    { "enum": 2, "tipoVinculo": "EMPREGO PÚBLICO" },
    { "enum": 3, "tipoVinculo": "SERVIDOR PÚBLICO ESTATUTÁRIO" },
    { "enum": 4, "tipoVinculo": "SERVIDOR PÚBLICO COMISSIONADO (SEM VÍNCULO)" },
    { "enum": 5, "tipoVinculo": "CARGO/FUNÇÃO NÃO REMUNERADA" },
    { "enum": 6, "tipoVinculo": "ESTÁGIO" },
    { "enum": 7, "tipoVinculo": "OUTRO" },
    { "enum": 8, "tipoVinculo": "AUTÔNOMO" },
]


export const lista_tipoEmail = [
    { "enum": 1, "tipoEmail": "PESSOAL" },
    { "enum": 2, "tipoEmail": "INSTITUCIONAL" }
]

export const lista_tipoTelefone = [
    { "enum": 1, "tipoTelefone": "Celular Pessoal" },
    { "enum": 2, "tipoTelefone": "Celular Institucional" },
    { "enum": 11, "tipoTelefone": "Fixo Pessoal" },
    { "enum": 12, "tipoTelefone": "Fixo Institucional" },
]


//Outros:
//  Arquivo EnumsParaDirigenteExcepcional.tsx
